<template>
  <v-card>
    <v-card-title>
      <v-col>
        <v-row>
          <span class="text-h5">
            {{ $t('ITEM.CREATE') }} {{ $t('APARTMENTS.ITEM') }}
          </span>
        </v-row>
        <v-row v-if="buildings.length === 1">
          <span class="text-h5">
            ({{ buildings[0].street }}, {{ buildings[0].name }})
          </span>
        </v-row>
      </v-col>
    </v-card-title>

    <v-card-text>
      <div v-if="errors.any()">
        <v-alert
          v-for="(message, index) in errors.getAllMessages()"
          :key="index"
          color="error"
          dark
          dense
        >
          {{ message }}
        </v-alert>
      </div>

      <div v-if="limitIsAchieved">
        <v-alert type="error">
          {{ $t('MESSAGE.DATA_FROM_NAME_FLOOR_DESCRIPTION_LIMIT_LENGTH') }}
        </v-alert>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <apartment-form
          v-model="apartment"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        >
          <template v-slot:buttons>
            <v-layout align-center justify-space-between row>
              <v-btn outlined text @click="$emit('cancel')">{{
                $t('BUTTON.CANCEL')
              }}</v-btn>

              <v-btn
                color="primary"
                :disabled="!valid"
                :loading="loading"
                @click="validate"
              >
                {{ $t('BUTTON.CREATE') }}
              </v-btn>
            </v-layout>
          </template>
        </apartment-form>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import ApartmentForm from '@/components/apartments/components/ApartmentForm';
import errors from '@/modules/_global/mixins/errors';

export default {
  name: 'ApartmentCreate',

  components: { ApartmentForm },

  mixins: [errors],

  props: {
    buildings: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    apartment: {
      presentation: false
    },

    valid: true
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    },

    limitIsAchieved() {
      let sum = 0;

      try {
        sum += this.apartment.name.length;
      } catch {
        sum += 0;
      }

      try {
        sum += this.apartment.floor.length;
      } catch {
        sum += 0;
      }

      try {
        sum += this.apartment.access_description.length;
      } catch {
        sum += 0;
      }

      return sum > 56;
    }
  },

  methods: {
    validate() {
      if (this.$refs.form.validate() && !this.limitIsAchieved) {
        this.$store
          .dispatch('apartment/store', {
            ...this.apartment,
            building_id: this.buildings[0].id
          })
          .then(({ data }) => {
            this.$store.commit('snackbar/setSnack', {
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });

            this.$emit('success', data);
          })
          .then(() => {
            this.$emit('refreshBuildings');
            this.$emit('cancel');
          })
          .catch(error => {
            this.handleErrorsByResponse(error.response);
            this.$store.commit('loading', false);
          });
      }
    }
  }
};
</script>
